module.exports = __webpack_public_path__ + "static/img/team2.189062f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instructors/team2.jpg
// module id = hOd+
// module chunks = 1